<template>
  <div class="home-wrap">
    <div>
      <div class="student-top">
        <div class="student-info">
          <div class="student-box">
            <div class="student-box-img">
              <img
                :src="
                  childData.Icon ? api + childData.Icon : require('@/assets/attendance/yrykb.png')
                "
                alt
              />
            </div>
            <div class="student-box-right nowrap">
              <div class="student-box-student nowrap">
                <span>{{ childData.FullNameStudent }}</span>
                <span class="student-line">|</span>
                <span>{{ childData.SchoolDistrictName }}</span>
              </div>
              <div class="student-box-school nowrap">
                {{ childData.StudentYearName }}{{ childData.StudentGradeName
                }}{{ childData.StudentOrganizationName }}
              </div>
            </div>
          </div>
        </div>
        <div class="common-top">
          <ul class="common-ul">
            <li v-for="item in list" :key="item.ID" @click="goto(item)">
              <div class="common-img">
                <img :src="require('@/assets/parent/' + item.Icon)" alt />
              </div>
              <div class="common-name">{{ item.Name }}</div>
            </li>
          </ul>
        </div>
      </div>
      <div class="student-message">
        <div class="message-img" v-if="isMsg && isStatus">
          <div>
            <p class="message-img-title">消息通知</p>
            <p class="message-img-desc">
              <i class="iconfont">&#xe606;</i>
              <span>您有未读消息</span>
            </p>
          </div>
        </div>
        <div class="msg-info" v-if="isMsg">
          <div
            class="msg-list nowrap"
            v-for="(item, index) in SelfMessageList"
            :key="index"
            @click="msgBtn(item)"
          >
            <div class="msg-left">
              <div
                class="msg-left-icon"
                :style="{ background: item.Status === 0 ? '#4196ff' : '#98c1fb' }"
              >
                <i class="iconfont">&#xe617;</i>
                <div class="point" v-if="item.Status === 0"></div>
              </div>
            </div>
            <div class="msg-center nowrap">
              <div class="msg-title nowrap">{{ item.Subject }}</div>
              <div class="msg-desc nowrap">{{ item.MessageDescribe }}</div>
              <div class="msg-type nowrap">
                接收时间：{{ item.CreateByDate }}&nbsp;&nbsp;&nbsp;&nbsp;触发者：{{
                  item.SenderName
                }}
              </div>
              <!-- <div class="msg-type nowrap">模块：{{item.MessageTypeName}}</div> -->
            </div>
            <div class="msg-right">
              <div class="msg-btn">
                <van-icon name="arrow" color="#fff" />
              </div>
            </div>
          </div>
        </div>
        <div v-if="!isMsg">
          <div class="message-info">
            <div class="message-null">
              <div class="message-null-img">
                <img :src="require('@/assets/common/nullinfo.png')" alt />
              </div>
              <div>暂无消息</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "home",
  data() {
    return {
      list: [],
      api: "",
      SelfMessageList: [],
      isMsg: false,
      isStatus: null
    };
  },
  computed: {
    childData() {
      return this.$store.state.parentInfo.childData; //当前孩子信息
    }
    // allChild() {
    //   return this.$store.state.parentInfo.childList; //所有孩子信息
    // }
  },
  created() {
    this.api = this.xyMApi;
    this.getFrequently();
    this.getSelfMessage();
  },
  methods: {
    async getFrequently() {
      //获取当前用户模块
      this.xy.loading();
      let res = await this.xyapi.get(`${this.xyMApi}/xy/comm/MobileMoudle`, null);
      if (res.success) {
        this.list = res.data[0].applications;
      }
      this.xy.unloading();
    },
    async getSelfMessage() {
      // 获取全部消息
      this.SelfMessageList = [];
      let params = {
        // -1全部消息，0未读消息，1已读消息
        status: -1,
        beginDate: "",
        endDate: "",
        pageIndex: 1,
        pageSize: 7
      };
      let res = await this.xyapi.get(
        this.xyMApi + "/msg/api/Message/GetPageSelf",
        params
      );
      if (res.success) {
        this.SelfMessageList = res.data.data;
        this.isMsg = this.SelfMessageList.length > 0 ? true : false;
        if (this.SelfMessageList.length > 0) {
          this.SelfMessageList.map(item => {
            if (item.Status === 0) {
              this.isStatus = true;
            }
          });
        }
      }
    },
    async msgBtn(val) {
      if (val.Status === 0) {
        //标记为已读
        await this.xyapi.post(
          `${this.xyMApi}/msg/api/message/SetStatus?status=1&messageID=${val.MessageID}`
        );
      }
      // if (this.$store.apiPath !== val.ServiceDoMainName) {
      //   this.$store.commit("changeApiPath", val.ServiceDoMainName);
      // }
      this.$store.commit("changeMessageInfo", val);
      // 消息路由跳转
      this.$router.push({
        path: val.DetailMobileUrl,
        query: { fromMessage: true }
      });
    },
    goto(val) {
      //this.$store.commit("changeApiPath", val.ServiceDoMainName);
      this.$store.commit("parentInfo/changeModuleData", JSON.stringify(val));
      this.$router.push(val.MobileUrl);
    }
  }
};
</script>
<style lang="less" scoped>
.home-wrap {
  height: 100%;
  display: flex;
  flex-flow: column;
  .header-title {
    font-size: 30px;
  }
}
.student-top {
  background: #fff;
  box-shadow: 0 3px 15px 0 rgba(151, 151, 151, 0.2);
}
.header-style {
  height: 120px;
  color: #ffffff;
  background: #4196ff;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 100px;
}
.student-info {
  width: 100%;
  height: 150px;
  background-image: url(../../../../../assets/parent/home-bg.png);
  background-size: 100% 100%;
  background-repeat: no-repeat;
  position: relative;
  .student-box {
    position: absolute;
    bottom: -40px;
    left: 50%;
    margin-left: -269px;
    width: 538px;
    height: 140px;
    background: #fff;
    border-radius: 40px;
    display: flex;
    align-items: center;
    padding: 0 20px;
    .student-box-img {
      width: 106px;
      height: 106px;
      border-radius: 50%;
      background: #eee;
      img {
        display: block;
        width: 100%;
        height: 100%;
        border-radius: 50%;
      }
    }
    .student-box-right {
      margin-left: 20px;
      flex: 1;
      .student-box-student {
        font-size: 30px;
        color: #111;
        font-weight: bold;
        margin-bottom: 20px;
        .student-line {
          margin: 0 10px;
          color: #ccc;
          font-weight: normal;
        }
      }
      .student-box-school {
        font-size: 26px;
        color: #666;
      }
    }
  }
}
.common-top {
  margin-top: 40px;
  padding-bottom: 30px;
  .common-title {
    font-size: 32px;
    color: #0a0a0a;
    padding: 0 20px 0;
  }
  .common-ul {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    li {
      text-align: center;
      width: 20%;
      margin-top: 32px;
      .common-img {
        img {
          width: 80px;
        }
      }
      .common-name {
        margin-top: 20px;
        font-size: 24px;
      }
    }
  }
}
.student-message {
  margin-top: 20px;
  padding-bottom: 10px;
  overflow-y: auto;
}
.message-img {
  text-align: center;
  div {
    width: 702px;
    height: 143px;
    margin: 0 auto;
    background-image: url("../../../../../assets/common/message.png");
    background-size: 100% 100%;
    background-repeat: no-repeat;
    p {
      width: 361px;
      margin-left: 100px;
    }
    .message-img-title {
      color: #fff;
      font-size: 36px;
      font-weight: bold;
      padding-top: 10px;
    }
    .message-img-desc {
      text-align: left;
      padding-left: 20px;
      font-size: 24px;
      height: 44px;
      line-height: 44px;
      background: rgba(12, 24, 145, 0.2);
      border-radius: 22px;
      color: #ebbf4a;
      margin-top: 20px;
      i {
        font-size: 22px;
        margin-right: 20px;
      }
    }
  }
}
.msg-info {
  padding: 20px;
  .msg-list {
    display: flex;
    justify-content: space-between;
    background: #fff;
    padding: 20px;
    margin-bottom: 16px;
    box-shadow: 0 4px 16px 0 rgba(197, 197, 197, 0.5);
    border-radius: 12px;
    .msg-left {
      width: 40px;
      .msg-left-icon {
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
        width: 40px;
        height: 40px;
        border-radius: 50%;
        .iconfont {
          font-size: 22px;
          color: #fff;
        }
        .point {
          position: absolute;
          top: -4px;
          right: 2px;
          width: 12px;
          height: 12px;
          background: #ff9500;
          border-radius: 50%;
        }
      }
    }
    .msg-center {
      flex: 1;
      display: flex;
      flex-flow: column;
      padding: 0 20px 0 10px;
      .msg-title {
        font-size: 28px;
        color: #333;
      }
      .msg-desc {
        font-size: 26px;
        color: #666;
        padding: 20px 0 5px;
      }
      .msg-type {
        font-size: 22px;
        color: #b7b7b7;
        padding: 5px 0;
      }
    }
    .msg-right {
      width: 60px;
      display: flex;
      align-items: center;
      justify-content: center;
      .msg-btn {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 48px;
        height: 48px;
        background: #4a98fd;
        box-shadow: 0 4px 12px 0 rgba(50, 133, 255, 0.41);
        border-radius: 50%;
      }
    }
  }
}
.message-info {
  padding: 20px;
  .message-null {
    text-align: center;
    font-size: 28px;
    color: #7f7f7f;
    padding: 12px;
    border-radius: 32px;
    .message-null-img {
      width: 80%;
      margin: 20px auto 60px;
      img {
        width: 100%;
      }
    }
  }
}
</style>
